import React from 'react'
import { COLOR } from './colors.js'
import { FONT } from './fonts.js'
import { FX } from './fx.js'

const tag = document.createElement('style')

const typography = `
	.h1-style {
		font-family: 'Suisse', 'Helvetica Neue', Helvetica, Arial, sans-serif;
		font-weight: 500;
		font-size: 64px;
		line-height: 64px;
		letter-spacing: -3px;
	}
	.h2-style {
		font-family: 'Suisse', 'Helvetica Neue', Helvetica, Arial, sans-serif;
		font-weight: 400;
		font-size: 48px;
		line-height: 40px;
		letter-spacing: -2px
	}
	.h3-style {
		font-family: 'Suisse', 'Helvetica Neue', Helvetica, Arial, sans-serif;
		font-weight: 400;
		font-size: 36px;
		line-height: 40px;
		letter-spacing: -2px;
	}
	.h4-style {
		font-family: 'Suisse', 'Franklin Gothic Medium', Tahoma, sans-serif;
		font-weight: 300;
		font-size: 24px;
		line-height: 30px;
	}
	.h5-style {
		font-family: 'Suisse', 'Franklin Gothic Medium', Tahoma, sans-serif;
		font-weight: 300;
		font-size: 20px;
		line-height: 30px;
	}
	.h6-style {
		font-family: 'Suisse', 'Franklin Gothic Medium', Tahoma, sans-serif;
		font-size: 18px;
		line-height: 30px;
	}
	.p-style {
		font-family: 'Suisse', 'Franklin Gothic Medium', Tahoma, sans-serif;
		font-weight: 300;
		font-size: 20px;
		line-height: 30px;
	}
	.p-small-style {
		font-family: 'Suisse', 'Franklin Gothic Medium', Tahoma, sans-serif;
		font-weight: 400;
		font-size: 13px;
		line-height: 21px;
	}
	.button-style {

	}

	.link-button-primary a {
		text-decoration: none;
		display: block;
		max-width: 350px;
		width: 100%;
		text-align: center;
		height: 50px;
		background: ${COLOR.primary};
		color: ${COLOR.white};
		line-height: 50px;
		font-family: "Suisse";
		font-size: 24px;
		letter-spacing: -0.5px;
		border-radius: 6px;
		font-weight: 300;
		cursor: pointer;
		box-shadow: ${FX.shadow.default};
		transition-duration: ${FX.speed.fast};
	}
	.link-button-primary a:hover {
		box-shadow: ${FX.shadow.hover};
		transition-duration: ${FX.speed.fast};
		transform: scale(${FX.scale.hover});
	}
	.link-button-primary a:active:hover {
		box-shadow: ${FX.shadow.default};
		transition-duration: ${FX.speed.fast};
		transform: scale(1);
	}

	.link-button-primary button {
		text-decoration: none;
		display: block;
		max-width: 350px;
		width: 100%;
		text-align: center;
		height: 50px;
		background: ${COLOR.primary};
		color: ${COLOR.white};
		line-height: 50px;
		font-family: "Suisse";
		font-size: 24px;
		letter-spacing: -0.5px;
		border: 0;
		border-radius: 6px;
		font-weight: 300;
		cursor: pointer;
		outline: none;
		padding: 0;
		box-shadow: ${FX.shadow.default};
		transition-duration: ${FX.speed.fast};
	}
	.link-button-primary button:hover {
		box-shadow: ${FX.shadow.hover};
		transition-duration: ${FX.speed.fast};
		transform: scale(${FX.scale.hover});
	}
	.link-button-primary button:active:hover {
		box-shadow: ${FX.shadow.default};
		transition-duration: ${FX.speed.fast};
		transform: scale(1);
	}

	.link-button-secondary a {
		text-decoration: none;
		display: block;
		max-width: 350px;
		width: 100%;
		text-align: center;
		height: 50px;
		background: ${COLOR.light};
		color: ${COLOR.primary};
		line-height: 50px;
		font-family: "Suisse";
		font-size: 24px;
		letter-spacing: -0.5px;
		border-radius: 6px;
		font-weight: 300;
		cursor: pointer;
		box-shadow: ${FX.shadow.default};
		transition-duration: ${FX.speed.fast};
	}
	.link-button-secondary a:hover {
		box-shadow: ${FX.shadow.hover};
		transition-duration: ${FX.speed.fast};
		transform: scale(${FX.scale.hover});
	}
	.link-button-secondary a:active:hover {
		box-shadow: ${FX.shadow.default};
		transition-duration: ${FX.speed.fast};
		transform: scale(1);
	}

	@media (max-width: 500px) {
		.h2-style {
			font-size: 36px;
		}
	}
`

tag.appendChild(document.createTextNode(typography))
tag.setAttribute('type', 'text/css')
document.head.appendChild(tag)


const h1 = (style, ...children) => {
	return <h1 className="h1-style" style={style}>{children}</h1>
}

const h2 = (style, ...children) => {
	return <h2 className="h2-style" style={style}>{children}</h2>
}

const h3 = (style, ...children) => {
	return <h3 className="h3-style" style={style}>{children}</h3>
}

const h4 = (style, ...children) => {
	return <h4 className="h4-style" style={style}>{children}</h4>
}

const h5 = (style, ...children) => {
	return <h5 className="h5-style" style={style}>{children}</h5>
}

const h6 = (style, ...children) => {
	return <h6 className="h6-style" style={style}>{children}</h6>
}

const text = (style, ...children) => {
	return <p className="p-style" style={style}>{children}</p>
}

const textSmall = (style, ...children) => {
	return <p className="p-small-style" style={style}>{children}</p>
}

const button = (style, ...children) => {
	return <button className="button-style" style={style}>{children}</button>
}

const linkButtonPrimary = (style, ...children) => {
	return <div className="link-button-primary" style={style}>{children}</div>
}

const linkButtonSecondary = (style, ...children) => {
	return <div className="link-button-secondary" style={style}>{children}</div>
}

export { h1, h2, h3, h4, h5, h6, text, textSmall, button, linkButtonPrimary, linkButtonSecondary, COLOR, FX, FONT }
